module.exports = __webpack_public_path__ + "static/img/UBC老师_老杜.3883996.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UBC/UBC老师_老杜.png
// module id = kPB1
// module chunks = 0